import {
  SET_CLINICS,
  SET_SELECTED_CLINIC,
  DELETE_CLINIC_ID,
  CLINIC_DETAILS,
  EDIT_CLINIC_ID,
  DELETE_GROUP_STATUS,
  PATIENTS_SHARED,
  STATEMENT_SELECTED_CLINIC,
  SET_CLINIC_NOTIFICATION_BATCHES,
  BILLING_CLINIC_ID,
  GROUP_TYPE
} from './Index';

// For logging in the user
export const _setClinics = (
  clinics: any,
  selectedClinic?: string
): any => async (dispatch: any) => {
  dispatch({type: SET_CLINICS, payload: {clinics, selectedClinic}});
};

export const _setSelectedClinic = (selectedClinic?: string): any => async (
  dispatch: any
) => {
  dispatch({type: SET_SELECTED_CLINIC, payload: {selectedClinic}});
};
export const _deleteClinicId = (deleteClinicId?: string): any => async (
  dispatch: any
) => {
  dispatch({type: DELETE_CLINIC_ID, payload: {deleteClinicId}});
};

export const _editClinicDetails = (editClinicDetails: any): any => async (
  dispatch: any
) => {
  dispatch({type: CLINIC_DETAILS, payload: {editClinicDetails}});
};

export const _editClinicId = (editClinicId: any): any => async (
  dispatch: any
) => {
  dispatch({type: EDIT_CLINIC_ID, payload: {editClinicId}});
};
export const _deleteGroupStatus = (deleteGroupStatus: any): any => async (
  dispatch: any
) => {
  dispatch({type: DELETE_GROUP_STATUS, payload: {deleteGroupStatus}});
};

export const _patientsShared = (
  patientShared: any,
  emrProvider: any,
  splitStatement: boolean,
  isMultiColumnMapping: boolean,
  consolidatedBillingGroupEnable: any,
  billingClinicId: number,
  showBillingPractice: any
): any => async (dispatch: any) => {
  dispatch({
    type: PATIENTS_SHARED,
    payload: {
      patientShared,
      emrProvider,
      splitStatement,
      isMultiColumnMapping,
      consolidatedBillingGroupEnable,
      billingClinicId,
      showBillingPractice
    }
  });
};

export const _statementsSelectedClinic = (
  selectedClinicId: any,
  selectedClinicLabel: any,
  zone: any,
  emrProvider: any
): any => (dispatch: any) => {
  dispatch({
    type: STATEMENT_SELECTED_CLINIC,
    payload: {selectedClinicId, selectedClinicLabel, zone, emrProvider}
  });
};

export const _clinicNotificationBatchIds = (clinicNotificationBatches: {
  clinicId: string | number;
  notificationBatches: any[];
}): any => (dispatch: any) => {
  dispatch({
    type: SET_CLINIC_NOTIFICATION_BATCHES,
    payload: {clinicNotificationBatches}
  });
};

export const _setBillingClinicId = (
  billing_clinic_id: number | null
): any => async (dispatch: any) => {
  dispatch({type: BILLING_CLINIC_ID, payload: {billing_clinic_id}});
};
export const _groupType = (grouptype: any): any => async (dispatch: any) => {
  dispatch({type: GROUP_TYPE, payload: {grouptype}});
};
